/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * アカウント状態
 * @export
 * @enum {number}
 */
export enum AccountStatusEnum {
    /** 未連携 */
    UNLINKED = 0,
    /** 連携済 */
    LINKED = 1
}

/**
 * アカウント状態 の Union 型
 * @export
 * @typedef AccountStatus
 */
export type AccountStatus =
  typeof AccountStatusEnum[keyof typeof AccountStatusEnum];

/**
 * アカウント状態 のラベルマップ
 * @export
 */
export const AccountStatusLabels = {
    /**
     * 数値キー: AccountStatusEnum.UNLINKED
     * 名前キー:  UNLINKED
     */
    [AccountStatusEnum.UNLINKED]: '未連携',
    UNLINKED:                             '未連携',
    /**
     * 数値キー: AccountStatusEnum.LINKED
     * 名前キー:  LINKED
     */
    [AccountStatusEnum.LINKED]: '連携済',
    LINKED:                             '連携済',
} as const;

/**
 * アカウント状態 のラベル Union 型
 * @export
 * @typedef AccountStatusLabel
 */
export type AccountStatusLabel =
  typeof AccountStatusLabels[keyof typeof AccountStatusLabels];

/**
 * アカウント状態 のラベル取得関数
 * @export
 * @param { AccountStatus } value - 列挙体の値
 * @returns { AccountStatusLabel } ラベル文字列
 */
export function getAccountStatusLabel(
  value: AccountStatus
): AccountStatusLabel {
  return AccountStatusLabels[value];
}

/**
 * アカウント状態 のラベル配列を取得する関数
 * @export
 * @param { AccountStatus[] } values - 列挙体の値配列
 * @returns { AccountStatusLabel[] } ラベル文字列配列
 */
export function getAccountStatusLabels(values: AccountStatus[]): AccountStatusLabel[] {
  return values.map((value) => getAccountStatusLabel(value));
}

/**
 * アカウント状態 のラベル配列
 * @export
 */
export const AccountStatusLabelList = [
  '未連携','連携済',
] as const;

